<template>
	<div class="button-area">
		<button id="cta" class="anim" @click="$emitter.emit('register', whereAmI)" :class="buttonClass">
			<h2 v-if="threeDayTrial">
				Get 3 months for $1/mo
			</h2>
			<h2 v-else>
				{{ trialDays === '30' ? 'Claim Your Free Month Now' : 'Start 14-Days Free' }}
			</h2>

			<img src="@/assets/images/home/v6/arrow.svg" />
		</button>
		<h4 v-if="showButtonCaption">Get {{ trialDays }} days for free! 🎁</h4>
	</div>
</template>
<script setup>
	import { defineProps, inject } from 'vue'
	import { useLandingPage } from '@/stores/landingPage'
	const landingPage = useLandingPage()
	const trialDays = landingPage.trialDays || 14
	const threeDayTrial = landingPage.threeDayTrial
	const $emitter = inject('$emitter')
	const props = defineProps({
		showButtonCaption: {
			type: Boolean,
			default: true,
		},
		buttonClass: {
			type: String,
		},
		whereAmI: {
			type: String,
		},
	})
</script>
<style lang="scss" scoped>
	#cta {
		padding: 18px 28px 20px 28px;
		border-radius: 18px;
		background: var(--stan-positive-primary-color);
		color: #131f60;
		outline: none;
		border: none;
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 15px;
		transition: 0.2s ease !important;
		box-shadow: 0 16px 24px rgba(black, 0.02);

		h2 {
			font-size: 24px;
			font-weight: 800;
			letter-spacing: 0px;
			margin: 0;
		}
		img {
			height: 20px;
		}
		&:hover {
			gap: 30px;
		}
		@media screen and (max-width: 1200px) {
			padding: 16px 24px 18px 22px;
			gap: 14px;
			border-radius: 16px;

			h2 {
				font-size: 20px;
				line-height: 26px;
			}
			h4 {
				font-size: 14px;
			}
		}
		@media screen and (max-width: 767px) {
			padding: 20px;
			gap: 24px;

			h2 {
				font-size: 18px;
				line-height: 19px;
			}
			h4 {
				font-size: 14px;
			}
		}
	}
	.button-area {
		align-items: center;
		display: flex;
		flex-direction: column;
		gap: 10px;
		h4 {
			font-size: 16px;
			color: var(--stan-text-light-color);
			@media screen and (max-width: 767px) {
				font-size: 14px;
			}
		}
	}
</style>
